var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.371722221374512, 1.875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.17 9.84 C 21.09 9.67 20.96 9.53 20.80 9.43 C 20.64 9.33 20.46 9.28 20.27 9.28 L 20.27 9.28 L 11.74 9.32 L 11.69 9.27 L 12.86 1.13 C 12.90 0.92 12.86 0.70 12.75 0.51 C 12.64 0.32 12.48 0.17 12.28 0.08 C 12.15 0.03 12.02 0.00 11.88 0.00 C 11.73 0.00 11.59 0.03 11.46 0.10 C 11.32 0.16 11.21 0.26 11.12 0.37 L 0.22 13.96 C 0.10 14.11 0.03 14.28 0.01 14.47 C -0.01 14.65 0.02 14.84 0.10 15.01 C 0.18 15.18 0.30 15.32 0.46 15.42 C 0.62 15.51 0.80 15.57 0.99 15.57 L 8.67 15.57 L 8.72 15.63 L 6.75 25.06 C 6.70 25.28 6.73 25.50 6.83 25.70 C 6.92 25.90 7.08 26.06 7.28 26.15 C 7.48 26.25 7.71 26.27 7.92 26.23 C 8.14 26.18 8.33 26.06 8.47 25.89 L 21.03 10.90 C 21.15 10.75 21.23 10.58 21.25 10.39 C 21.28 10.20 21.25 10.01 21.17 9.84",
    fill: "#4b1498",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureLightning);
export default __webpack_public_path__ + "static/media/feature-lightning.d8a00093ff46efcdbdac7c2ea4062ed1.svg";
export { ForwardRef as ReactComponent };